/**
 * AccountCreationStep - Step 6: Create account with password
 */
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Lock, CheckCircle, AlertCircle } from 'lucide-react';

export const AccountCreationStep = ({ 
  pendingId,
  token,
  guardianEmail,
  accountForm,
  setAccountForm,
  onSubmit,
  submitting,
  onSessionExpired
}) => {
  if (!pendingId) {
    return (
      <Card className="bg-white/5 border-white/10">
        <CardHeader>
          <CardTitle className="text-white flex items-center gap-2">
            <Lock className="w-5 h-5 text-[#FF007F]" />
            Create Your Account
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="p-4 bg-red-500/10 border border-red-500/30 rounded-lg text-red-400 text-center">
            <AlertCircle className="w-6 h-6 mx-auto mb-2" />
            <p>Registration session expired. Please restart the registration process.</p>
            <Button
              variant="outline"
              onClick={onSessionExpired}
              className="mt-4 border-red-500/30 text-red-400 hover:bg-red-500/10"
            >
              Restart Registration
            </Button>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className="bg-white/5 border-white/10">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <Lock className="w-5 h-5 text-[#FF007F]" />
          Create Your Account
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="p-4 bg-emerald-500/10 rounded-lg border border-emerald-500/30 mb-4">
          <p className="text-sm text-emerald-400 flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            Card saved successfully! Now create your account to access the parent portal.
          </p>
        </div>

        <div>
          <Label className="text-white/70">Email</Label>
          <Input
            type="email"
            value={guardianEmail}
            disabled
            className="bg-white/10 border-white/10 text-white/70"
          />
        </div>
        
        <div>
          <Label className="text-white/70">Create Password *</Label>
          <Input
            type="password"
            value={accountForm.password}
            onChange={(e) => setAccountForm({ ...accountForm, password: e.target.value })}
            className="bg-white/5 border-white/10 text-white"
            placeholder="At least 8 characters"
            data-testid="account-password"
          />
        </div>
        
        <div>
          <Label className="text-white/70">Confirm Password *</Label>
          <Input
            type="password"
            value={accountForm.confirmPassword}
            onChange={(e) => setAccountForm({ ...accountForm, confirmPassword: e.target.value })}
            className="bg-white/5 border-white/10 text-white"
            placeholder="Confirm your password"
            data-testid="account-confirm-password"
          />
        </div>

        <Button 
          onClick={onSubmit}
          disabled={submitting}
          className="w-full bg-[#FF007F] hover:bg-[#D6006A] text-white h-12"
          data-testid="create-account-button"
        >
          {submitting ? 'Creating Account...' : 'Create Account & Access Portal'}
        </Button>
      </CardContent>
    </Card>
  );
};

export default AccountCreationStep;
